<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-form class="px-2">
        <!-- Rule Type -->
        <v-flex xs4>
          <v-select v-model="ruleInfo.type" item-text="title" item-value="value" v-validate="'required'"
            :error-messages="errors.collect('type')" data-vv-name="type" :disabled="isEditMode"
            @change="handleRuleTypeChange" :label="messages.label.RULE_TYPE" :items="ruleTypeList"></v-select>
        </v-flex>
        <!-- Rule Title -->
        <v-flex xs10>
          <v-text-field v-model="ruleInfo.title" clearable v-validate="{ required: true, max:100, regex: /^[0-9a-zA-Z\s\/_-]*$/i }"
            :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
            :label="messages.label.RULE_TITLE" required>
          </v-text-field>
        </v-flex>
        <!-- Rule Description -->
        <v-flex xs10>
          <v-textarea v-model="ruleInfo.description" clearable v-validate="{max:500}"
            :error-messages="errors.collect('description')" data-vv-name="description" :counter="500"
            :label="messages.label.RULE_DESCRIPTION" required>
          </v-textarea>
        </v-flex>
        <!-- Rule Enabled -->
        <v-flex xs4>
          <span class="subheading grey--text text--darken-2">{{
              messages.label.ENABLED
          }}</span>
          <v-switch v-model="ruleEnabled" color="primary" class="mt-0" :label="`${ruleEnabled.toString()}`"></v-switch>
        </v-flex>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import messages from "@/XVAT/messages.json"
import XVATRulesService from "@/XVAT/XVATRulesService"
import {
  RULE_TYPE_VALIDATION
} from "../constants"

export default {
  name: "RuleInfo",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      ruleTypeList: XVATRulesService.getRuleTypeList("rule"),
      isEditMode: false,
      ruleInfo: {
        type: RULE_TYPE_VALIDATION,
        title: "",
        description: "",
        enabled: true
      },
      ruleEnabled: true, // NOTE: Using this outside of 'ruleInfo' as binding is not working
      dictionary: this.getValidationDictionary()
    }
  },
  methods: {
    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          type: {
            required: () => "Please select rule type"
          },
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters",
            regex: "Valid characters are : A-Z a-z 0-9 / _ -"
          },
          description: {
            max: "Description may not be greater than 500 characters"
          }
        }
      }
    },

    /**
     * resetData - Reset rule info data
     */
    resetData() {
      this.ruleInfo = {
        type: RULE_TYPE_VALIDATION,
        title: "",
        description: "",
        enabled: true
      }
      this.ruleEnabled = true
      this.isEditMode = false
    },

    /**
     * resetRuleInfo - Reset rule data and form
     */
    resetRuleInfo() {
      this.resetData()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },

    /**
     * loadRuleInfo - update view with rule info data
     * @param {object} ruleData
     */
    loadRuleInfo(ruleData) {
      this.resetRuleInfo()
      if (!this.$lodash.isUndefined(ruleData)) {
        this.isEditMode = true
        this.ruleInfo.type = ruleData.type
        this.ruleInfo.title = ruleData.title
        this.ruleInfo.description = decodeURI(ruleData.description)
        this.ruleInfo.enabled = !ruleData.disabled
        this.ruleEnabled = this.ruleInfo.enabled // UI Specific
      } else {
        this.isEditMode = false
      }
    },

    /**
     * validate - validate form and dispatch event to notify
     */
    validate() {
      this.$validator.validateAll().then(result => {
        this.ruleInfo.enabled = this.ruleEnabled // Please see note at the definition of this property in 'data'
        if (this.$lodash.isNull(this.ruleInfo.description)) {
          this.ruleInfo.description = ""
        }
        XVATRulesService.$emit(
          "event:ruleInfoValidation",
          result,
          this.ruleInfo
        )
      })
    },

    /**
     * Dispatch event to communicate rule type change
     */
    handleRuleTypeChange() {
      XVATRulesService.$emit("event:ruleTypeChange", this.ruleInfo.type)
    }
  },
  mounted() {
    // Validator initialization
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    XVATRulesService.$on("event:ruleDataRetrieved", this.loadRuleInfo)
    XVATRulesService.$on("event:validateRuleInfo", this.validate)
  },
  beforeDestroy() {
    XVATRulesService.$off("event:validateRuleInfo", this.validate)
    XVATRulesService.$off("event:ruleDataRetrieved", this.loadRuleInfo)
  }
}
</script>
<style lang="sass"></style>



// WEBPACK FOOTER //
// src/XVAT/Rule/RuleInfo.vue